import { EndpointBuilderService } from '~/src/dash/utils/endpointBuilderService';

export function getParameterValue(
  service: EndpointBuilderService,
  rokuValue: string,
  googleValue: string,
  freewheelValue: string,
  springserveValue: string,
  defaultValue: string,
): string {
  if ((service.getChip('Trafficked In', 'root', 'GAM') || { selected: false }).selected) {
    return googleValue;
  }
  if ((service.getChip('Trafficked In', 'root', 'Roku') || { selected: false }).selected) {
    return rokuValue;
  }
  if ((service.getChip('Trafficked In', 'root', 'SpringServe') || { selected: false }).selected) {
    return springserveValue;
  }
  if ((service.getChip('Trafficked In', 'root', 'Freewheel') || { selected: false }).selected) {
    return freewheelValue;
  }
  return defaultValue;
}

export function areAnyChipTextsSelected(
  service: EndpointBuilderService,
  title: string,
  subtitle: string,
  chipTexts: string[],
): boolean {
  for (const chipText of chipTexts) {
    if (isChipTextSelected(service, title, subtitle, chipText)) {
      return true;
    }
  }
  return false;
}

export function isChipTextSelected(
  service: EndpointBuilderService,
  title: string,
  subtitle: string,
  chipText: string,
): boolean {
  return !!(service.getChip(title, subtitle, chipText) || { selected: false }).selected;
}

export function isAChipInSubtitleSelected(
  service: EndpointBuilderService,
  title: string,
  subtitle: string,
): boolean {
  // get subtitle
  const subtitleObj = service.getSubtitle(title, subtitle);
  if (!subtitleObj) {
    return false;
  }
  // iterate through chips
  for (const chip of subtitleObj.chips) {
    if (chip.selected) {
      return true; // found a selected chip
    }
  }
  return false; // didn't found a selected chip
}
